import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const UsersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/users" */
    'routes/Control/Users/UsersRoute'
  )
));

const UserDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/user-details" */
    'routes/Control/Users/DetailsRoute'
  )
));

const getControlUsersRoutes = () => {
  return [
    {path: paths.getPathControlUsers(), component: UsersRoute},
    {path: paths.getPathControlUserDetails(":userId"), component: UserDetailsRoute},
  ]
}



export { getControlUsersRoutes };
